import type { ReactNode } from "react";

export function InfoCard({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <section className="rounded-xl border-2 border-card-border px-6 pt-4 pb-6">
      <h2 className="text-20 leading-[27px] font-bold">{title}</h2>
      <hr className="mt-[6px] border-t border-divider-strong" />
      <div className="mt-3 flex flex-col gap-[6px]">{children}</div>
    </section>
  );
}
